<template>
  <section class="section section--portfolio" id="portfolio">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
      <path d="M0 100 C 20 0 50 0 100 100 Z" />
    </svg>
    <div class="section__inner">
      <div class="block">
        <h2>Recent work</h2>
        <div class="snowie__work__grid">
          <div v-for="proj in projects" class="snowie__work__grid--item">
            <a @click="showDetailsModal(proj)" class="snowie__work__grid--link">
              <img :src="require(`@/assets/img/work/${proj.img}`)" />
              <div class="snowie__work__grid--item--caption">{{ proj.caption }}</div>
            </a>
            <!-- <Modalv2 v-bind:data="proj" /> -->

            <!-- <div class="snowie__work-desc">{{proj.caption}}</div> -->
          </div>
        </div>
      </div>
    </div>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="100%"
      height="100"
      viewBox="0 0 100 102"
      preserveAspectRatio="none"
      class="bottom"
    >
      <path d="M0 0 L50 100 L100 0 Z" />
    </svg>
  </section>
</template>

<script>
import Modalv2 from "../componentsv2/Modal";

export default {
  name: "Work",
  components: {
    Modalv2
  },
  data() {
    return {
      projects: [
        {
          name: "Panda VOD",
          link: "https://www.pandavod.tv/",
          caption: "Front-end Development",
          img: "pandavod-desktop.png",
          desc:
            "This is a movie & tv series streaming web app which includes viral videos & news for the Chinese community. This is an adaptive website, it was supposed to be a responsive website but due to design changes, we decided it is better to be adaptive. The desktop version is made with basic front-end technologies (HTML5, CSS, jQuery, Node) connect with umbraco as the backend. The mobile version is made with Vue connecting to API."
        },
        {
          name: "Pacific Place HK",
          link: "http://www.pacificplace.com.hk/",
          caption: "Front-end Development",
          img: "pp.png",
          desc:
            "Pacific Place is a luxury complex of office towers, hotels and a shopping center developed by Swire Properties. This website displays promotions, events, store tenants information and much more. This website showcases various complicated yet elegant animations, custom components for different page functions."
        },
        {
          name: "ISIET UK",
          link: "https://isietuk.com/",
          caption: "Front-end Development",
          img: "isietuk.png",
          desc:
            "ISIET is designed as an assessment platform that helps schools identify the most appropriate students and families to find the right school for their child. This is a responsive web page that displays information about their services."
        },
        {
          name: "ISIET UK Exam",
          link: "http://exam.isietuk.com/",
          caption: "Front-end Development",
          img: "isietukExam.png",
          desc:
            "ISIET Exam provides the testing and training services of the British Private School Entrance Examination. The test is divided into five parts: English, mathematics, linguistic reasoning ability, non-verbal reasoning ability, and writing. Their target audience is mainly the Chinese community."
        },
        {
          name: "3d Joe & Max",
          link: "http://3djoeandmax.com/",
          caption: "Wordpress Development",
          img: "3djoe.png",
          desc:
            "Joe & Max (aka 3D Joe & Max) are artists who have traveled the globe creating their artworks for a range of clients including Google, Disney, Reebok, Save the Children and Coca-Cola. This is a simple Wordpress Theme development."
        }
      ]
    };
  },
  methods: {
    showDetailsModal(proj) {
      this.$modal.show(
        Modalv2,
        {
          data: proj
        },
        {
          adaptive: true,
          height: "auto",
          transition: "nice-modal-fade",
          scrollable: true
        }
      );
    }
  }
};
</script>

<style lang="scss">
.section--portfolio {
  background-color: $theme5;
  color: white;
  .section__inner {
    max-width: 100% !important;
  }

  svg {
    top: -20px;
    fill: $theme5;

    &.bottom {
      top: auto;
      bottom: -50px;
      fill: $theme5;
    }
  }

  .snowie__work {
    &__grid {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: space-between;
      &--link {
        cursor: pointer;
      }
      &--item {
        @media (max-width: 1000px) {
          padding: 10px;
          width: 50%;
        }
        @media (max-width: 700px) {
          padding: 10px;
          width: 100%;
        }
        width: 19%;
        position: relative;
        &:hover {
          .snowie__work__grid--item--caption {
            display: flex;
          }
        }

        &--caption {
          background: black;
          opacity: 0.8;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
          color: white;
          display: none;
          font-size: 24px;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
